export default "__VITE_ASSET__oMw6zTcm__"